export function mapPriorityToStatus(priority: string): 'danger' | 'warning' | 'neutral' | 'inactive' {
  switch (priority?.toUpperCase()) {
    case 'URGENT':
      return 'danger';
    case 'HIGH':
      return 'warning';
    case 'MEDIUM':
      return 'neutral';
    case 'LOW':
      return 'inactive';
    default:
      return 'neutral';
  }
}

